export default class Appointement {
  constructor(rawData) {
    this.content = rawData;
  }

  getAppointementTypes() {
    const typesArray = [];
    Object.keys(this.content).forEach((e) => {
      if (this.content[e] && this.content[e].length) typesArray.push(e);
    });
    if (typesArray.length !== 1) {
      typesArray.unshift('Tous');
    }
    return typesArray || [];
  }

  getAppointementsByDay() {
    // Each index represent a day of the week.
    // started by sunday, because "this.content" ios formated this way.
    // We push sunday at the end of the week, at the end of the function.
    const res = new Array(7).fill().map(() => []);
    Object.keys(this.content).forEach((type) => {
      if (this.content[type] instanceof Array === false) return;
      this.content[type].forEach(({ day, slots }) => {
        const slotsWithTypes = slots.map((slot) => ({ ...slot, type }));
        res[day] = [...res[day], ...slotsWithTypes];
      });
    });
    // Move 1st element to the end as sunday is the last day of week in FR
    res.push(res.shift());
    // Sort by starting hour.
    res.forEach((day) => {
      day.sort((a, b) => a.start - b.start);
    });
    return res;
  }
}
